import { ReactNode, useEffect, useState } from 'react';
import { Props as ReactApexChartProps } from 'react-apexcharts';
import { useLang } from '../../../../../../hooks/use-lang';
import { DashboardChartsWidgetModalType } from './dashboard-charts-widget/dashboard-charts-widget-modal/dashboard-charts-widget-modal';
import { IgnoredTasksType } from '../../dashboard-helpers';

export interface ChartInvalidData {
  maxTime: number;
  onChangeMaxTime: (value: number) => void;
  ignoredTasks: IgnoredTasksType[];
}

export interface ChartFilters {
  sections?: {
    sectionIds?: string[];
    onChangeSectionIds: (value: string[]) => void;
  };
  categories?: {
    categoryIds?: string[];
    onChangeCategoryIds: (value: string[]) => void;
  };
}

export interface ChartProps extends ReactApexChartProps {
  label: string;
  /** Скрыть карточку визуально, но оставить в DOM для стабильной CSS-сетки по nth-child */
  hidden?: boolean;
  subLabel?: string;
  /** Ключ для t(): текст подсказки у заголовка */
  labelTooltip?: string;
  /** Дополнительный CSS-класс панели tooltip у заголовка */
  tooltipPanelClassName?: string;
  /** Показать «!» с подсказкой по hover (нужен labelTooltip) */
  labelInfoIcon?: boolean;
  wrapped?: boolean;
  invalidData?: ChartInvalidData;
  tableData?: unknown;
  filters?: ChartFilters;
  /** Опциональный блок под графиком (например, чекбоксы категорий для пирамиды) */
  footer?: ReactNode;
  /** Карточка на всю ширину сетки (2 колонки на десктопе) */
  fullWidth?: boolean;
}

export const useDashboardCharts = () => {
  const { t, currentLang } = useLang();

  const [openSettingsModal, setOpenSettingsModal] = useState<DashboardChartsWidgetModalType>();

  useEffect(() => {
    // @ts-ignore
    Apex.chart.defaultLocale = currentLang;
  }, [currentLang]);

  return {
    t,
    openSettingsModal,
    setOpenSettingsModal,
  };
};
